import { render, staticRenderFns } from "./MessageRedactionModal.vue?vue&type=template&id=7a5685ce&scoped=true&"
import script from "./MessageRedactionModal.vue?vue&type=script&lang=js&"
export * from "./MessageRedactionModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageRedactionModal.vue?vue&type=style&index=0&id=7a5685ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5685ce",
  null
  
)

export default component.exports